export const getDigits = x => (x + '').indexOf('.') ? (x + '').split('.')[1].length : 0
